import HttpService from "./http-service";
import BudgetExecution, {
  BudgetExecutionAccount,
} from "@/entities/budget-execution";

export default class ButgetExecution extends HttpService {
  // TODO: Change unknown to a type
  public async getAccountGroups(withAccounts = false): Promise<unknown[]> {
    const params = { with_accounts: withAccounts };
    const { data } = await this.httpClient.get(
      "budget-execution-account-groups",
      { params }
    );
    return data;
  }
}

export interface BudgetExecutionDTO {
  id: number;
  name: string;
  accounts: Array<BudgetExecutionAccount>;
}

export function BudgetExecutionAccountsFromDTO(
  dto: BudgetExecutionDTO
): BudgetExecution {
  return new BudgetExecution({
    id: dto.id,
    name: dto.name,
    accounts: dto.accounts,
  });
}
